import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { UserFlag } from '@xingternal/user-flag';

import { pathOr } from '@xingternal/malt-util/objects';
import { ProfileImage } from '@xingternal/profile-image';
import { TrackedLink, eitherOr } from '@xingternal/xing-tracking';
import { useMediaListener } from '@xingternal/util';

import styles from './Me.css';

const genderMap = {
  FEMALE: 'female-user',
  MALE: 'male-user',
  NONE: 'neutral-user',
};

const Me = ({ className, collapsed, patternId, user }) => {
  const { displayName, profileImage, gender, userFlags } = user;
  const image = pathOr(null, [0, 'url'], profileImage);
  const breakpoint = useMediaListener();
  const displayFlag = (userFlags && userFlags?.displayFlag) || null;

  const trackingConditions = {
    sc_o_PropActionOrigin: eitherOr(displayName),
  };

  return (
    <TrackedLink
      className={cx(className, styles.profile)}
      conditions={trackingConditions}
      to="/profile"
      trackingKey="profile"
    >
      <figure
        className={cx(styles.innerProfile, {
          [styles.collapsed]: collapsed,
        })}
      >
        <ProfileImage
          size={collapsed ? 'small' : 'medium'}
          patternId={`me-profile-picture${patternId ? `-${patternId}` : ''}`}
          profileName={displayName}
          className={styles.figure}
          src={image}
          type={genderMap[gender]}
        />

        <figcaption className={styles.caption}>
          {displayFlag && (
            <UserFlag
              data-qa="me-badge"
              displayFlag={displayFlag}
              showBasicFlag
              size={breakpoint === 'tablet' ? 'small' : 'medium'}
            />
          )}
          <p
            className={cx(styles.userName, {
              [styles.emptyUserName]: !displayName,
            })}
          >
            {displayName}
          </p>
        </figcaption>
      </figure>
    </TrackedLink>
  );
};

Me.defaultProps = { collapsed: false, patternId: '' };

Me.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  patternId: PropTypes.string,
  user: PropTypes.object,
};

export { Me };
